<template>
  <div v-loading="loading || childLoading">
    <template v-if="treeDataSource.length <= 0">
      <el-alert
        title="Ops"
        :type="mensagemErro.erro ? 'error' : 'info'"
        :description="mensagemErro.msg"
        show-icon
      ></el-alert>
    </template>
    <template v-if="treeDataSource.length > 0">
      <tree-table ref="recTree" :list.sync="treeDataSource" @handlerExpand="handlerExpand"></tree-table>
    </template>
  </div>
</template>
<script>
import TreeTable from "@/components/TreeTableDRE";
export default {
  props: {
    dataJson: { type: Array },
    mensagemErro: { type: Object }
  },
  data() {
    return {
      treeDataSource: [],
      loading: true,
      childLoading: true
    };
  },
  components: {
    TreeTable
  },
  watch: {
    dataJson: function(newData) {
      this.treeDataSource = newData;
      this.loading = false;
    }
  },
  methods: {
    handlerExpand(m) {
      m.isExpand = !m.isExpand;
    }
  },
  created() {
    this.$root.$on("loading", val => {
      this.childLoading = val;
    });
  }
};
</script>